import axios from 'axios';
import config from '../../../config';


class LiveAgentConnexion {

    constructor(printMessageFunction, stopConversationFunction) {
        this.config = config.liveAgentConfig;
        this.sequence = 1;
        this.printMessage = printMessageFunction;
        this.stopChatConversation = stopConversationFunction;
        this.sessionKey = '';
        this.sessionId = '';
        this.type = '';
        this.subtype = '';
        this.service = '';
        this.pullingLoop = true;
    }

    getSessionId = (type, subtype, service) => {
        return new Promise((resolve, reject) => {
            axios.get(`${this.config.chatAPIEndpoint}/key`)
                .then((response) => {
                    this.sessionKey = response.data.key;
                    this.sessionId = response.data.id;
                    this.sendInitMessage(type, subtype, service)
                        .then(resp => {
                            return resolve(resp);
                        })
                        .catch(err => reject(err));
                })
                .catch(err => reject(err));
        })
    }

    getMessages = async () => {
        return await new Promise((resolve, reject) => {
            const body = {
                key: this.sessionKey,
                sequence: this.sequence
            }
            axios.post(`${this.config.chatAPIEndpoint}/getmsgs`, body)
                .then((response) => {
                    return resolve(response);
                })
                .catch(err => reject(err));
        })
    }

    /*
    startPullingLoop = () => {
        this.pullingLoop = setInterval(() => {
            this.getMessages()
                .then((response) => {
                    console.log('startPullingLoop ' + response)
                    if (!this.pullingLoop) return;
                    response.data.messages.forEach((message) => {
                        if (message.type === "ChatMessage") {
                            this.printMessage(message.message.text);
                        } else if (message.type === "ChatEnded") {
                            this.conversationEnd();
                        } else if (message.type === "ChatEstablished") {
                            this.printMessage("Para asegurar que te damos la mejor ayuda posible, necesito que, por favor, <strong>escribas brevemente lo que te ocurre</strong>");
                        }
                    })
                })
                .catch((err) => {
                    this.printMessage(null, err);
                    if (this.pullingLoop) this.conversationEnd();
                })
        }, 39000)
    }
    */

    startPullingLoop = async () => {
        await this.getMessages()
            .then((response) => {
                this.pullingLoop = true;
                if (response.data.messages !== undefined) {

                    response.data.messages.forEach((message) => {

                        if (message.type === "ChatMessage") {

                            let msg = message.message.text;
                            let matches = msg.match(/\b(http|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/gi);

                            if (matches != null) {
                                if (matches.length != 0) {
                                    for (let i = 0; i < matches.length; i++) {
                                        let match = '<a href=\'' + matches[i] + '\' target=\'_blank\'>' + matches[i] + '</a>';
                                        msg = msg.replace(matches[i], match);
                                    }
                                }
                            }

                            this.printMessage(msg);

                        } else if (message.type === "ChatEnded") {
                            this.pullingLoop = false;
                            this.conversationEnd();
                        } /*else if (message.type === "ChatEstablished") {
                            this.printMessage("Para asegurar que te damos la mejor ayuda posible, necesito que, por favor, <strong>escribas brevemente lo que te ocurre</strong>");
                        }*/
                    })

                    if (this.pullingLoop) {
                        this.startPullingLoop();
                    }

                } else {
                    this.startPullingLoop();
                }
            })
            .catch((err) => {
                this.printMessage(null, err);
                this.conversationEnd();
            })
    }

    sendMessage = async (text) => {
        return await new Promise((resolve, reject) => {
            const body = {
                key: this.sessionKey,
                sequence: this.sequence,
                text: text
            }
            axios.post(`${this.config.chatAPIEndpoint}/sendmsg`, body)
                .then(response => {
                    this.sequence++;
                    return resolve(response)
                })
                .catch((err) => {
                    this.printMessage(null, err);
                    this.conversationEnd();

                });
        });
    }

    sendInitMessage = (type, subtype, service) => {
        return new Promise((resolve, reject) => {
            const body = {
                key: this.sessionKey,
                sequence: this.sequence,
                id: this.sessionId,
                type: type,
                subtype: subtype,
                service: service,
                language: "en"
            }
            axios.post(`${this.config.chatAPIEndpoint}/init`, body)
                .then(response => {
                    this.sequence++;
                    this.startPullingLoop();
                    return resolve(response)
                })
                .catch((err) => {
                    this.printMessage(null, err);
                    this.conversationEnd();
                })
        });
    }

    conversationEnd = () => {
        this.pullingLoop = null;
        this.stopChatConversation();
    }
}

export default LiveAgentConnexion;